import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SocioData from '../../services/socio-service';
import './dashboard.css';
import PeopleData from '../../services/people-service';

export const Dashboard = ({ accessToken }) => {
  const [socioData, setSocioData] = useState(null);
  const [people, setPeopleData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const sociogramData = await SocioData.getSociogramList(accessToken);
        const peopleData = await PeopleData.getData(accessToken);
        setSocioData(sociogramData);
        setPeopleData(peopleData);
        setLoading(false);
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    };
    fetchData();
  }, [accessToken]);

  const formatDate = (epochTime) => {
    if (!epochTime) return 'N/A';
    const date = new Date(epochTime);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading dashboard...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <h1>You are not authenticated</h1>
        <Link to="/">
          <button className="btn btn-primary btn-block contact">
            Back home
          </button>
        </Link>
      </div>
    );
  }

  if (!people) {
    return (
      <div>
        <h1>To get started, please create some people in your account.</h1>
        <Link to="/people">
          <button className="btn btn-primary btn-block contact">
            Create People
          </button>
        </Link>
      </div>
    );
  }

  if (!socioData || socioData.length === 0) {
    return (
      <div>
        <h1>You have not created any sociograms yet</h1>
        <Link to="/create">
          <button className="btn btn-primary btn-block contact">
            Create New Sociogram
          </button>
        </Link>
      </div>
    );
  }

  const rows = socioData.map((item, i) => {
    const socioLink = "/sociogram/" + item.id;
    // only count people if people are configured for the sociogram
    let personCount = 0;
    if (item.people) personCount = item.people.length;
    
    return (
      <div className="three-rows" key={item.id || i}>
        <div>
          <Link to={socioLink}>
            {item.name}
          </Link>
        </div>
        <div>
          {formatDate(item.createdAt)}
        </div>
        <div>
          {personCount}
        </div>
      </div>
    );
  });

  return (
    <div className="dash-parent">
      <h1>Here are the sociograms you have created so far..</h1>
      <div className="dash-header">
        <div>Name</div>
        <div>Created</div>
        <div>Number of people</div>
      </div>
      {rows}
    </div>
  );
};

export default Dashboard;